import React from 'react';
import classNames from 'classnames';
import { OptionProps, Select } from '../Select';
import styles from './SelectWithLabel.module.scss';

interface SelectWithLabelProps {
	ariaLabel: string;
	id: string;
	name: string;
	options: OptionProps[];
	value: string;
	required?: boolean;
	errorText?: string;
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
	className?: string;
	variant?: 'default' | 'inverse';
}

/**
 * Generic Select component with label and error validation, used for select input components.
 * NOT for navigation links, but for submitting user input.
 * For navigation, please see Dropdown.
 */

export const SelectWithLabel: React.FunctionComponent<SelectWithLabelProps> = ({
	ariaLabel,
	id,
	name,
	options,
	value,
	required,
	errorText,
	onChange,
	className,
	variant = 'default',
}) => {
	return (
		<div>
			<label
				htmlFor={id}
				className={classNames(styles.label, {
					[styles.required]: required,
					[styles.hasError]: !!errorText?.length,
				})}
			>
				{ariaLabel}
			</label>

			<Select
				className={classNames(styles.select, className)}
				ariaLabel={ariaLabel}
				options={options}
				name={name}
				id={id}
				value={value}
				variant={variant}
				errorText={errorText}
				onChange={onChange}
			/>
			{errorText && <p className={styles.errorText}>{errorText}</p>}
		</div>
	);
};
